// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__gdQ8B3jDk05JWm9DGH1X {
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    sans-serif;

  /* based on fluent v8 colors https://developer.microsoft.com/en-us/fluentui#/styles/web/colors/theme-slots */
  --cp-themeDarker: #004578;
  --cp-themeDark: #005a9e;
  --cp-themeDarkAlt: #106ebe;
  --cp-themePrimary: #0078d4;
  --cp-black: black;
  /* used in transparent colors */
  --cp-blackRgb: 0 0 0;
  --cp-neutralDark: #201f1e;
  --cp-neutralPrimary: #323130;
  --cp-neutralSecondary: #605e5c;
  --cp-neutralSecondaryAlt: #8a8886;
  --cp-neutralTertiary: #a19f9d;
  --cp-neutralTertiaryAlt: #c8c6c4;
  --cp-neutralLight: #edebe9;
  --cp-neutralLighter: #f3f2f1;
  --cp-neutralLighterAlt: #faf9f8;
  --cp-white: white;
  --cp-whiteRgb: 255 255 255;

  /* Status colors (dark ones are also hardcoded in icons) */
  --cp-errorDark: #a4262c;
  --cp-errorMed: #ffb8b8;
  --cp-errorLight: #ffebeb;
  --cp-errorTransparent: #dc000033;
  --cp-warningDark: #b88700;
  --cp-warningMed: #e6cd89;
  --cp-warningLight: #fffaeb;
  --cp-warningTransparent: #ffe2944d;
  /* successDark: #00aa00 */
  --cp-successMed: #7ad17a;
  --cp-successLight: #e9f9e9;

  --cp-text: var(--cp-neutralPrimary);
  --cp-textHover: var(--cp-neutralDark);
  --cp-textDisabled: var(--cp-neutralTertiary);
  --cp-bgDisabled: var(--cp-neutralLighter);
  --cp-border: var(--cp-neutralSecondaryAlt);
  --cp-borderHover: var(--cp-neutralPrimary);
  --cp-borderDisabled: var(--cp-neutralLighter);
  /* accordion item, dialog header/task list divider */
  --cp-borderSubtle: var(--cp-neutralTertiaryAlt);

  --cp-zIndexDialog: 99999;
  --cp-zIndexBadge: 99998;

  --cp-fontSizeSm: 12px;
  --cp-fontSizeMd: 14px;
  --cp-fontSizeLg: 16px;
  --cp-fontSizeTitle: 24px;

  /* default child styles */
  color: var(--cp-text);
  font-size: var(--cp-fontSizeMd);
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThemeProvider/ThemeProvider.module.css"],"names":[],"mappings":"AAAA;EACE;;;;;;;;;;;;cAYY;;EAEZ,4GAA4G;EAC5G,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;EACjB,0BAA0B;;EAE1B,0DAA0D;EAC1D,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,gCAAgC;EAChC,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;;EAE1B,mCAAmC;EACnC,qCAAqC;EACrC,4CAA4C;EAC5C,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,6CAA6C;EAC7C,oDAAoD;EACpD,+CAA+C;;EAE/C,wBAAwB;EACxB,uBAAuB;;EAEvB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;;EAExB,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;AAClB","sourcesContent":[".root {\n  font-family:\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    'Fira Sans',\n    'Droid Sans',\n    'Helvetica Neue',\n    sans-serif;\n\n  /* based on fluent v8 colors https://developer.microsoft.com/en-us/fluentui#/styles/web/colors/theme-slots */\n  --cp-themeDarker: #004578;\n  --cp-themeDark: #005a9e;\n  --cp-themeDarkAlt: #106ebe;\n  --cp-themePrimary: #0078d4;\n  --cp-black: black;\n  /* used in transparent colors */\n  --cp-blackRgb: 0 0 0;\n  --cp-neutralDark: #201f1e;\n  --cp-neutralPrimary: #323130;\n  --cp-neutralSecondary: #605e5c;\n  --cp-neutralSecondaryAlt: #8a8886;\n  --cp-neutralTertiary: #a19f9d;\n  --cp-neutralTertiaryAlt: #c8c6c4;\n  --cp-neutralLight: #edebe9;\n  --cp-neutralLighter: #f3f2f1;\n  --cp-neutralLighterAlt: #faf9f8;\n  --cp-white: white;\n  --cp-whiteRgb: 255 255 255;\n\n  /* Status colors (dark ones are also hardcoded in icons) */\n  --cp-errorDark: #a4262c;\n  --cp-errorMed: #ffb8b8;\n  --cp-errorLight: #ffebeb;\n  --cp-errorTransparent: #dc000033;\n  --cp-warningDark: #b88700;\n  --cp-warningMed: #e6cd89;\n  --cp-warningLight: #fffaeb;\n  --cp-warningTransparent: #ffe2944d;\n  /* successDark: #00aa00 */\n  --cp-successMed: #7ad17a;\n  --cp-successLight: #e9f9e9;\n\n  --cp-text: var(--cp-neutralPrimary);\n  --cp-textHover: var(--cp-neutralDark);\n  --cp-textDisabled: var(--cp-neutralTertiary);\n  --cp-bgDisabled: var(--cp-neutralLighter);\n  --cp-border: var(--cp-neutralSecondaryAlt);\n  --cp-borderHover: var(--cp-neutralPrimary);\n  --cp-borderDisabled: var(--cp-neutralLighter);\n  /* accordion item, dialog header/task list divider */\n  --cp-borderSubtle: var(--cp-neutralTertiaryAlt);\n\n  --cp-zIndexDialog: 99999;\n  --cp-zIndexBadge: 99998;\n\n  --cp-fontSizeSm: 12px;\n  --cp-fontSizeMd: 14px;\n  --cp-fontSizeLg: 16px;\n  --cp-fontSizeTitle: 24px;\n\n  /* default child styles */\n  color: var(--cp-text);\n  font-size: var(--cp-fontSizeMd);\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__gdQ8B3jDk05JWm9DGH1X`
};
export default ___CSS_LOADER_EXPORT___;
